import React from 'react';
import PropTypes from 'prop-types';

/**
 * Simple component to be included in any page that requires an active session.
 * Will redirect to login page if there is not one.
 */
class SessionChecker extends React.Component {
  constructor(props) {
    super(props);
    this.props.checkSession();
  }

  render() {
    return null;
  }
}

SessionChecker.propTypes = {
  checkSession: PropTypes.func

};

export default SessionChecker;



/** WEBPACK FOOTER **
 ** ./src/components/Change/SessionChecker.js
 **/